import { Component } from '@angular/core';

@Component({
    selector: 'guern-cms-admin', // if we want to boostrap the admin only
    template: '<router-outlet></router-outlet>',
})
export class AdminAppComponent {

    constructor(){
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-app.component.ts